import { createAction, props } from '@ngrx/store';


export const loadBcsNotifications = createAction(
    '[AppHeader] Load User Alerts',
    props<{ tenantId: number, userId: number, fromUtcDate: string }>()
);